import React, { useEffect, useState } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import ja from 'date-fns/locale/ja'
import { ScheduleBox } from '../../common/formParts/FieldPartsStyled'
import "react-datepicker/dist/react-datepicker.css";
import SelectTime from '../../common/formParts/SelectTime'

registerLocale('ja', ja)

const ScheduleType = (props) => {
  const [occurenceDateTime, setOccurenceDateTime] = useState(
    props.easy_news.occurence_datetime ? new Date(props.easy_news.occurence_datetime) : null
  );
  const [occurenceStartDatetime, setOccurenceStartDateTime] = useState(
    props.easy_news.occurence_start_datetime ? new Date(props.easy_news.occurence_start_datetime) : null
  );
  const [occurenceEndDatetime, setOccurenceEndDateTime] = useState(
    props.easy_news.occurence_end_datetime ? new Date(props.easy_news.occurence_end_datetime) : null
  );
  const [aboutTimeStart, setAboutTimeStart] = useState(props.easy_news.about_time_start || false)
  const [aboutTimeEnd, setAboutTimeEnd] = useState(props.easy_news.about_time_end || false)
  const handleAboutTimeStart = (isAboutTimeStart) => {
    setAboutTimeStart(isAboutTimeStart);
  };
  const handleAboutTimeEnd = (isAboutTimeEnd) => {
    setAboutTimeEnd(isAboutTimeEnd);
  };
  const [type, setType] = useState(props.dateTimeType || 'none')

  // extract hh:mm as a string from time select input
  const extractTime = (date) => {
    if (!date) return ''
    const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    return hours + ':' + minutes
  }

  useEffect(() => {
    setType(props.dateTimeType)
  }, [props.dateTimeType, occurenceDateTime, occurenceStartDatetime, occurenceEndDatetime])

  const onChangeDayTime = (time) => {
    const hour = parseInt(time.value.split(':')[0]);
    const minute = parseInt(time.value.split(':')[1]);
    switch (props.dateTimeType) {
      case 'day_time':
        if (occurenceDateTime) {
          setOccurenceDateTime(new Date(occurenceDateTime.setHours(hour, minute)))
        }
        break;
      case 'day_time_range':
        if (occurenceStartDatetime) {
          setOccurenceStartDateTime(new Date(occurenceStartDatetime.setHours(hour, minute)))
        }
        break;
      case 'day_range':
        if (occurenceStartDatetime) {
          setOccurenceStartDateTime(new Date(occurenceStartDatetime.setHours(hour, minute)))
        }
      default:
        break;
    }
  }

  const onChangeEndDayTime = (time) => {
    const hour = parseInt(time.value.split(':')[0]);
    const minute = parseInt(time.value.split(':')[1]);
    setOccurenceEndDateTime(new Date(occurenceEndDatetime.setHours(hour, minute)))
    setOccurenceDateTime(null)
  }

  useEffect(() => {
    if (props.dateTimeType === 'day_time') {
      setOccurenceDateTime(occurenceDateTime)
      setOccurenceStartDateTime(null)
      setOccurenceEndDateTime(null)
    } else if (props.dateTimeType === 'day_time_range'){
      setOccurenceStartDateTime(occurenceStartDatetime)

      if (occurenceStartDatetime) {
        const endDate = new Date(occurenceStartDatetime);
        endDate.setHours(occurenceEndDatetime.getHours(), occurenceEndDatetime.getMinutes());
        setOccurenceEndDateTime(endDate)
      } else {
        setOccurenceEndDateTime(occurenceEndDatetime)
      }

      setOccurenceDateTime(null)
    } else if (props.dateTimeType === 'day_range') {
      setOccurenceStartDateTime(occurenceStartDatetime)
      setOccurenceEndDateTime(occurenceEndDatetime)
      setOccurenceDateTime(null)
    } else {
      setOccurenceDateTime(null)
      setOccurenceStartDateTime(null)
      setOccurenceEndDateTime(null)
    }
  }, [props.dateTimeType])

  const handleDateChange = (date, type) => {
    let updatedDate = new Date(date);
    if (type === 'day_time') {
      if (!occurenceDateTime || (occurenceDateTime.getHours() === 0 && occurenceDateTime.getMinutes() === 0)) {
        updatedDate.setHours(23, 58);
      } else {
        updatedDate.setHours(occurenceDateTime.getHours(), occurenceDateTime.getMinutes());
      }
      setOccurenceDateTime(updatedDate);
    } else if (type === 'day_time_range') {
      if (!occurenceStartDatetime || (occurenceStartDatetime.getHours() === 0 && occurenceStartDatetime.getMinutes() === 0)) {
        updatedDate.setHours(23, 58);
      } else {
        updatedDate.setHours(occurenceStartDatetime.getHours(), occurenceStartDatetime.getMinutes());
      }
      setOccurenceStartDateTime(updatedDate);

      const endDate = new Date(date);
      if (!occurenceEndDatetime) {
        endDate.setHours(23, 58);
      } else {
        endDate.setHours(occurenceEndDatetime.getHours(), occurenceEndDatetime.getMinutes());
      }
      setOccurenceEndDateTime(endDate);
    } else if (type === 'start') {
      if (!occurenceStartDatetime || (occurenceStartDatetime.getHours() === 0 && occurenceStartDatetime.getMinutes() === 0)) {
        updatedDate.setHours(23, 58);
      } else {
        updatedDate.setHours(occurenceStartDatetime.getHours(), occurenceStartDatetime.getMinutes());
      }
      setOccurenceStartDateTime(updatedDate);
    } else if (type === 'end') {
      if (!occurenceEndDatetime || (occurenceEndDatetime.getHours() === 0 && occurenceEndDatetime.getMinutes() === 0)) {
        updatedDate.setHours(23, 58);
      } else {
        updatedDate.setHours(occurenceEndDatetime.getHours(), occurenceEndDatetime.getMinutes());
      }
      setOccurenceEndDateTime(updatedDate);
    }
  };
  
  // switch case for each type of schedule
  const renderScheduleBox = () => {
    switch (
      (type)) {
      case 'day_time':
        return (
          <ScheduleBox>
            <div className="datetimeLabel">日付</div>
            <DatePicker
              selected={occurenceDateTime}
              onChange={(date) => {handleDateChange(date, 'day_time')}}
              locale="ja"
              dateFormat='yyyy年M月d日'
              placeholderText="こちらに入力"
              className='selectField'
            />
            <div className="datetimeLabel">時刻</div>
            <div className='useTime'>
              <SelectTime
                {...props}
                onChange={onChangeDayTime}
                value={extractTime(occurenceDateTime) || ''}
                name='start_time'
                onAboutTimeStartChange={handleAboutTimeStart}
              />
              
            </div>
            <input type='hidden' name='easy_news[occurence_datetime]' value={occurenceDateTime ? occurenceDateTime : ''} />
            <input type='hidden' name='easy_news[occurence_datetime_type]' value='day_time' />
            <input type='hidden' name='easy_news[occurence_start_datetime]' value='' />
            <input type='hidden' name='easy_news[occurence_end_datetime]' value='' />
            <input type='hidden' name='easy_news[about_time_start]' value={aboutTimeStart} />
            <input type='hidden' name='easy_news[about_time_end]' value={aboutTimeStart} />
          </ScheduleBox>
        )
      case 'day_time_range':
        return (
          <ScheduleBox>
            <div className="datetimeLabel">日付</div>
            <DatePicker
              selected={occurenceStartDatetime}
              onChange={(date) => {handleDateChange(date, 'day_time_range')}}
              locale="ja"
              dateFormat='yyyy年M月d日'
              placeholderText="こちらに入力"
              className='selectField'
            />
            <div className="datetimeLabel">開始時刻</div>
            <div className='useTime'>
              <SelectTime
                {...props}
                onChange={onChangeDayTime}
                value={extractTime(occurenceStartDatetime) || ''}
                name='start_time'
                onAboutTimeStartChange={handleAboutTimeStart}
              />
              <div className="datetimeLabel">終了時刻</div>
              <SelectTime
                {...props}
                onChange={onChangeEndDayTime}
                value={extractTime(occurenceEndDatetime) || '23:58'}
                name='end_time'
                onAboutTimeEndChange={handleAboutTimeEnd}
              />
              <input type='hidden' name='easy_news[occurence_start_datetime]' value={occurenceStartDatetime ? occurenceStartDatetime : ''} />
              <input type='hidden' name='easy_news[occurence_end_datetime]' value={occurenceEndDatetime ? occurenceEndDatetime : ''} />
              <input type='hidden' name='easy_news[occurence_datetime_type]' value='day_time_range' />
              <input type='hidden' name='easy_news[occurence_datetime]' value='' />
              <input type='hidden' name='easy_news[about_time_start]' value={aboutTimeStart} />
              <input type='hidden' name='easy_news[about_time_end]' value={aboutTimeEnd} />
            </div>
          </ScheduleBox>
        )
      case 'day_range':
        return (
          <ScheduleBox>
            <div className='useTime'>
              <DatePicker
                selected={occurenceStartDatetime}
                onChange={(date) => handleDateChange(date, 'start')}
                locale="ja"
                dateFormat='yyyy年M月d日'
                placeholderText="開始日"
                className='datePickerRange'
              />
              <div className="datetimeLabel mt">開始時刻</div>
              <SelectTime
                {...props}
                onChange={onChangeDayTime}
                value={extractTime(occurenceStartDatetime) || ''}
                name='start_time'
                onAboutTimeStartChange={handleAboutTimeStart}
                />
              <span className="spacer"></span>
              <DatePicker
                selected={occurenceEndDatetime}
                onChange={(date) => handleDateChange(date, 'end')}
                locale="ja"
                dateFormat='yyyy年M月d日'
                placeholderText="終了日"
                className='datePickerRange'
              />
              <div className="datetimeLabel mt">終了時刻</div>
              <SelectTime
                {...props}
                onChange={onChangeEndDayTime}
                value={extractTime(occurenceEndDatetime) || ''}
                name='end_time'
                onAboutTimeEndChange={handleAboutTimeEnd}
                />
              <input type='hidden' name='easy_news[occurence_start_datetime]' value={occurenceStartDatetime ? occurenceStartDatetime : ''} />
              <input type='hidden' name='easy_news[occurence_end_datetime]' value={occurenceEndDatetime ? occurenceEndDatetime : ''} />
              <input type='hidden' name='easy_news[occurence_datetime_type]' value='day_range' />
              <input type='hidden' name='easy_news[occurence_datetime]' value='' />
              <input type='hidden' name='easy_news[about_time_start]' value={aboutTimeStart} />
              <input type='hidden' name='easy_news[about_time_end]' value={aboutTimeEnd} />
            </div>
          </ScheduleBox>
        )
      case 'none':
        return (
          <>
          <input type='hidden' name='easy_news[occurence_datetime_type]' value='none' />
          <input type='hidden' name='easy_news[occurence_datetime]' value='' />
          <input type='hidden' name='easy_news[occurence_start_datetime]' value='' />
          <input type='hidden' name='easy_news[occurence_end_datetime]' value='' />
          <input type='hidden' name='easy_news[about_time]' value={false} />
          <input type='hidden' name='easy_news[about_time_start]' value={false} />
          <input type='hidden' name='easy_news[about_time_end]' value={false} />
          </>
        )
      default:
        return (
          <>
          <input type='hidden' name='easy_news[occurence_datetime_type]' value='none' />
          <input type='hidden' name='easy_news[occurence_datetime]' value='' />
          <input type='hidden' name='easy_news[occurence_start_datetime]' value='' />
          <input type='hidden' name='easy_news[occurence_end_datetime]' value='' />
          <input type='hidden' name='easy_news[about_time]' value={false} />
          <input type='hidden' name='easy_news[about_time_start]' value={false} />
          <input type='hidden' name='easy_news[about_time_end]' value={false} />
          </>
        )
    }
  }

  return (
    <div className='scheduleBoxContainer'>
      { type && (renderScheduleBox()) }
    </div>
  )
}

export default ScheduleType
